// features/loyalty/loyalty.service.ts
import { get } from '../../api/api.service';

export interface ApiResponse {
  statusCode: number;
  message: string;
  response: LoyaltyTier[];
  totalCount: number;
}

export interface LoyaltyTier {
  loyaltyTierId: number;
  name: string;
  pointsRequired: number;
  discountPercentage: number;
  loyaltyType: number;
}

export interface LoyaltyDashboardData {
  statusCode: number;
  message: string;
  response: LoyaltyTier[];
  totalCount: number;
}

export interface MedalLevel {
  type: string;
  name: string;
  description: string;
  pointsRequired: number;
  discount: number;
}

export interface LoyaltyStatusData {
  statusCode: number;
  message: string;
  response: any; // We'll update this based on actual response structure
  totalCount: number;
}

export const fetchLoyaltyDashboardApi = async (): Promise<LoyaltyDashboardData> => {
  try {
    const response: ApiResponse = await get('/loyaltydashboard');
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchLoyaltyStatusApi = async (): Promise<LoyaltyStatusData> => {
  try {
    const response: LoyaltyStatusData = await get('/loyaltydashboard/status');
    return response;
  } catch (error) {
    throw error;
  }
};

// Points History API types and function
export interface LoyaltyPointsHistoryItem {
  id: string;
  icon?: string;
  title?: string;
  description?: string;
  points?: number;
  date?: string;
  isMilestone?: boolean;
  // API response properties
  comment?: string;
  data?: string;
  pointsGranted?: number;
  pointsGrantedDate?: string;
  actionTypeId?: number;
}

export interface LoyaltyPointsHistoryResponse {
  statusCode: number;
  message: string;
  response: LoyaltyPointsHistoryItem[];
  totalCount: number;
}

export const fetchLoyaltyPointsHistoryApi = async (pageNumber = 1, pageSize = 50): Promise<LoyaltyPointsHistoryResponse> => {
  try {
    const response: LoyaltyPointsHistoryResponse = await get(`/loyaltydashboard/points-history?PageNumber=${pageNumber}&PageSize=${pageSize}`);
    return response;
  } catch (error) {
    throw error;
  }
};
